import { PageHeader } from '@/components/layout/PageHeader';
import { PatientDownloadScreen } from '@/components/features/download/PatientDownloadScreen';
import { useActivities } from '@/hooks/useActivities';

export function PatientActivities() {
  // Use isCurrentPatient flag to load data from /patient/profile/
  const { activities, isLoading } = useActivities({ isCurrentPatient: true });

  return (
    <div>
      <PageHeader
        title="Download Activities"
        description="View and download your recorded activities"
      />
      <PatientDownloadScreen
        activities={activities}
        isLoading={isLoading}
        mode="processed"
      />
    </div>
  );
}
